import * as React from 'react';
import { AppContext, AppContextType } from '../AppContextType';
import { JobCenterModelInterface } from '../Model/JobCenterModelInterface';

export interface TransProps {
    id?: string;
    arguments?: any[];
}

export class Trans extends React.PureComponent<TransProps> {
    public static contextType = AppContextType;
    public context: AppContext<JobCenterModelInterface> = {} as AppContext<JobCenterModelInterface>;

    public render() {
        const i18n = this.context.i18n;
        const props = this.props;
        const children = props.children;
        const args = props.arguments || [];
        if (!props.id && typeof children !== 'string') {
            console.error('No ID given and children are not of type string');

            return null;
        }

        const id = '' + (props.id || children || '');
        if (!i18n.hasTranslation(id)) {
            return <span style={{display: 'inline-block', background: 'red', color: 'white'}}>
                Translation for `{id}` not found ({i18n.localeCode})
            </span>;
        }
        return this.prepareText(i18n.translate(id, args));
    }

    private prepareText(s: string): string {
        return s.replace(/&shy;/g, '\u00AD');
    }
}
